import * as React from 'react';

import { IconRegularChevronRight, Text } from '@notino/react-styleguide';

import { useFormattedPrice } from '@components/PriceLabel/useFormattedPrice';

import { LeftIconWrapper } from '../styled';

import { DeliveryDate, DeliveryInfoWrapper, Name } from './styled';

interface IDeliveryLineProps {
  showIcon: boolean;
  icon: JSX.Element;
  name: string;
  description: JSX.Element | string;
  isInactive: boolean;
  price: number;
  freeShippingText?: string;
}

export const DeliveryLine: React.FC<IDeliveryLineProps> = ({
  showIcon,
  icon,
  name,
  description,
  isInactive,
  price,
  freeShippingText,
}) => {
  const { formattedPriceWithCurrency } = useFormattedPrice({ value: price });

  return (
    <>
      <LeftIconWrapper>
        {showIcon &&
          React.cloneElement(icon, {
            color: isInactive ? 'icon.disabled' : 'icon.primary',
            width: '20px',
            height: '20px',
          })}
      </LeftIconWrapper>

      <DeliveryInfoWrapper>
        <Name isInactive={isInactive}>{name}</Name>

        <DeliveryDate isInactive={isInactive}>{description}</DeliveryDate>

        <Text typography="labelRegular" color="text.tertiary" marginTop="4px">
          {freeShippingText ?? formattedPriceWithCurrency}
        </Text>
      </DeliveryInfoWrapper>

      <IconRegularChevronRight width="1rem" height="1rem" />
    </>
  );
};
